import Sticky from 'sticky-js';

const MOBILE_PREVENT_CLICK = 'data-mobile-prevent-click'
const STICKY_ELEMENT = 'data-sticky'
const STICKY_TRIGGERS = 'data-sticky-trigger'

function init(){
  initMenuSubnav();
  initUserMenuButton();

  const $elements = document.querySelectorAll(`[${MOBILE_PREVENT_CLICK}]`);
  if ($elements.length) initMobilePreventClick($elements);

  const $stickyElements = document.querySelectorAll(`[${STICKY_ELEMENT}]`);
  if ($stickyElements.length) initSticky();

  const $extractsBlocks = document.querySelectorAll('[data-extract-slide]');
  if ($extractsBlocks.length) initExtractsBlock();

  // add a class when an input has been touched
  jQuery('.Webform').on('keyup change paste', 'input, select, textarea', function() {
    jQuery(this).addClass('Webform--input-touched');
  });
}

function initMobilePreventClick($elements) {
  $elements.forEach($element => {
    $element.addEventListener('click', e => {
      e.preventDefault();
    });
  });
}

function initSticky() {
  const $sticky = new Sticky(`[${STICKY_ELEMENT}]`);
  const $stickyTriggers = document.querySelectorAll(`[${STICKY_TRIGGERS}]`);
  let timer = 0;
  if ($stickyTriggers.length) {
    $stickyTriggers.forEach($trigger => {
      $trigger.addEventListener('mouseover', () => {
        if (timer !== 0) {
          clearTimeout(timer);
        }
        timer = setTimeout(() => {
          $sticky.update();
        }, 100);
      });
    });
  }
}

function initExtractsBlock() {
  const $slides = jQuery('[data-extract-slide]');
  const $slidesLinks = jQuery('[data-extract-slide] a');
  jQuery('[data-extract-slide]')
    .on('mouseover', function (event) {
      $slides.removeClass('active');
      jQuery(this).addClass('active');
    })
    .each((i, item) => {
      if (i === 0) {
        jQuery(item).addClass('active');
      }
    });
}

function initUserMenuButton() {
  let hoverTimeout;
  const $menu = jQuery('[data-menu-user]');
  $menu
    .on('mouseover click', function (event) {
      clearTimeout(hoverTimeout);
      $menu.addClass('hovered');
    })
    .on('mouseout', function (event) {
      const windowWidth = jQuery(window).width();
      const timeout = (windowWidth >= 1100) ? 500 : 0;
      hoverTimeout = setTimeout(function () {
        $menu.removeClass('hovered');
      }, timeout);
    });
}

function initMenuSubnav() {
  jQuery('[data-menu-toggler-touch]')
    .on('click', function (event) {
      const windowWidth = jQuery(window).width();
      if (windowWidth < 1100) {
        event.preventDefault();
        const $element = jQuery(this);
        jQuery('.Mainmenu-toggled').not($element.parents()).removeClass('Mainmenu-toggled');
        $element.parent().toggleClass('Mainmenu-toggled')
      }
    })
  // if menu opened and clicked outside of it, toggle it
  jQuery(document).on('click', (e) => {
    if (jQuery(window).width() >= 1100) {
      return;
    }
    const $element = jQuery(e.target);
    if ( ! $element.parents('.Mainmenu').length) {
      jQuery('.Mainmenu-toggled').removeClass('Mainmenu-toggled');
    }
  })
  jQuery('[data-menu-toggler-desktop]')
    .on('mouseenter', function (event) {
      const windowWidth = jQuery(window).width();
      const $element = jQuery(this);
      if (windowWidth >= 1100) {
        $element.addClass('Mainmenu-toggled');
        setTimeout(() => {
          const elementLeft = $element.offset().left;
          if (elementLeft > 0 && elementLeft > windowWidth/2) {
            $element.addClass('Mainmenu-toggled-left');
          }
        }, 10)
      }
    })
    .on('mouseleave', function (event) {
      const windowWidth = jQuery(window).width();
      if (windowWidth >= 1100) {
        jQuery(this).removeClass('Mainmenu-toggled')
      }
    })
}

export default { init }
